import _ from 'lodash';
import { SET_COLOR } from '../actions/actionCreators/colorPicker';

const initialState = {
    color: {
        r: 255,
        g: 255,
        b: 255,
    },
};

export default function colorPicker(state = initialState, action) {
    let newState = _.cloneDeep(state);
    switch (action.type) {
        case SET_COLOR:
            newState.color = action.color;
            return newState;
        default:
            return state;
    }
}
